<template>
  <v-card variant="flat" class="side_menu">
    <div v-for="(item,index) in menuItems" v-bind:key="index">
      <v-list class="menu_item" style="display: flex; gap: 10px;" 
        :class="selectedMenu === item.name ? 'active_menu' : ''" 
        @click="menuSelect(item)">
        <img :src="item.imageUrl" class="img_style" />
        {{ item.name }}
      </v-list>
      <div v-if="item.child && selectedMenu === item.name" class="submenu">
        <v-list v-for="(child, childIndex) in item.child" :key="childIndex" style="display: flex; gap: 10px;"
          class="submenu_item pb-3" 
          :class="selectedSubmenu === child.name ? 'active_submenu' : ''"
          @click="submenuSelect(child)">
          <img :src="child.imageUrl" class="img_style" />
          {{ child.name }}
        </v-list>
      </div>
    </div>
  </v-card>

</template>

<script>



export default {

  data: () => ({

    selectedMenu: 'About Client',
    selectedSubmenu: null,
    menuItems: [
      {
        name: "About Client",
        route: "/ClientDetails/aboutclient",
        imageUrl: require("@/assets/image/feedbac.png"),
      },
      {
        name: "Locations",
        route: "/ClientDetails/locations",
        imageUrl: require("@/assets/image/location.png"),
      },
      {
        name: "Client Organisation",
        route: "/ClientDetails/organisation",
        imageUrl: require("@/assets/image/handshake.png"),
      },
      {
        name: "Coreforce Team",
        route: "/ClientDetails/coreforceteam",
        imageUrl: require("@/assets/image/gear-assembly.png"),
      },
      {
        name: "Know Your Product",
        route: "/ClientDetails/knowyourproduct",
        imageUrl: require("@/assets/image/target-audience.png"),
      },
      {
        name: "Warehouse",
        route: "/ClientDetails/warehouse",
        imageUrl: require("@/assets/image/inventory-management.png"),
        child: [
           {
            name: "Warehouse Maintenance",
            route: "/ClientDetails/warehouse",
            imageUrl: require("@/assets/image/inventory-management.png"),
          },
          {
            name: 'Whse Contact',
            route: "/ClientDetails/wareouse",
            imageUrl: require("@/assets/image/call-phone.png"),
          }
        ]
      },

      {
        name: "Customers",
        route: "/ClientDetails/customers",
        imageUrl: require("@/assets/image/avatar.png"),
      },
      {
        name: "Routing Information",
        route: "/ClientDetails/routinginformation",
        imageUrl: require("@/assets/image/order-fulfillment.png"),
      },
      {
        name: "Factories",
        route: "/ClientDetails/factories",
        imageUrl: require("@/assets/image/factory.png"),
      },
      {
        name: "Process & SOP",
        route: "/ClientDetails/process&sop",
        imageUrl: require("@/assets/image/sop.png"),
      },
      {
        name: "Exceptions",
        route: "/ClientDetails/exceptions",
        imageUrl: require("@/assets/image/warning.png"),
      },
      {
        name: "WatchDog",
        route: "/ClientDetails/watchdoc",
        imageUrl: require("@/assets/image/telescope.png"),
      },
      {
        name: "Alerts",
        route: "/ClientDetails/alerts",
        imageUrl: require("@/assets/image/alert.png"),
        child: [
          {
            name: 'Common Alert',
            route: "/ClientDetails/commonalerts",
            imageUrl: require("@/assets/image/notification.png"),
          },
          {
            name: 'Customer Alert',
            route: "/ClientDetails/customeralerts",
            imageUrl: require("@/assets/image/megaphone.png"),
          }
        ]
      },
      {
        name: "Images",
        route: "/ClientDetails/images",
        imageUrl: require("@/assets/image/image.png"),
      },
      {
        name: "Process Flow",
        route: "/ClientDetails/processflow",
        imageUrl: require("@/assets/image/process.png"),
      },
    ]
  }),
  methods: {
    menuSelect(item) {
      if (this.selectedMenu === item.name && item.child) {
        this.selectedMenu = null
      } else {
        this.selectedMenu = item.name
      }
      this.selectedSubmenu = null
      if (item && item.route && !item.child) {
        console.log(item.route,"item.route!!!")
        this.$router.push({
            path: `${item.route}`,
            query: {id:this.$route.query.id},
        })
      }
    },
    submenuSelect(child) {
      this.selectedSubmenu = child.name
      if (child && child.route) {
        console.log(child.route,"child.route!!!")
        this.$router.push({
            path: `${child.route}`,
            query: {id:this.$route.query.id},
            menuName: this.selectedSubMenu
        })
      }
    }
  }

}

</script>

<style>
.side_menu {
  background-color: #EDEDFF;
  padding: 22px;
  border-radius: 4px;
  height: 100% !important;
  overflow-y: auto !important;
}

.menu_item {
  padding: 0;
  padding-bottom: 20px;
  background-color: #EDEDFF !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
}

.active_menu {
  font-weight: 700 !important;
}

.submenu {
  margin-left: 20px;
  padding-bottom: 10px;
}

.submenu_item {
  padding: 0;
  margin-bottom: 10px;
  background-color: #EDEDFF !important;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #666;
}

.active_submenu {
  font-weight: 600 !important;
  color: #000;
}

.img_style{
  width: 20px; 
  height: 20px;
}
</style>